import useFeatureEnabled from 'app/launch-darkly/use-feature-enabled';
import { FEATURE_FLAGS } from 'app/launch-darkly/featureFlags';

/**
 * Handles all the related flags that gate the consent mode dropdown are enabled.
 */
export default function useConsentModeEnabled() {
  const {
    configurableConsentMvpEnabled,
    ecmConfigurableConsentEnabled,
    consentModeEnabled: consentModeFlagEnabled,
  } = useFeatureEnabled(
    FEATURE_FLAGS.configurableConsentMvp,
    FEATURE_FLAGS.ecmConfigurableConsent,
    FEATURE_FLAGS.consentMode
  );

  const consentModeEnabled = configurableConsentMvpEnabled && ecmConfigurableConsentEnabled && consentModeFlagEnabled;

  return { consentModeEnabled };
}
